// Cluster de acciones del cliente: "Mi Perfil · Salir".
//
// Vive a la derecha de la misma franja donde va el wordmark, en cada pantalla
// del cliente. No es un shell ni un header: es solo el par de enlaces, para no
// repetirlo en cuatro archivos.
//
// Salir no pide confirmación — no es destructivo y la demo necesita velocidad.

import { useCliente } from './ClienteContext';

const ClienteActions = ({ onNavigate }) => {
  const { setCliente } = useCliente();

  const salir = () => {
    // setCliente(null) limpia el estado en memoria y borra la clave
    // desarrollos_current_client de sessionStorage (ver ClienteContext).
    setCliente(null);
    onNavigate('/desarrollos');
  };

  return (
    <div className="flex shrink-0 items-center gap-2 text-sm">
      <button
        type="button"
        onClick={() => onNavigate('/desarrollos/cliente/mi-perfil')}
        className="min-h-[44px] text-slate-700 transition-colors hover:underline"
      >
        Mi Perfil
      </button>
      <span aria-hidden="true" className="text-slate-300">
        ·
      </span>
      <button
        type="button"
        onClick={salir}
        className="min-h-[44px] text-slate-700 transition-colors hover:text-[var(--brand-teal)]"
      >
        Salir
      </button>
    </div>
  );
};

export default ClienteActions;
